


































































































import { Component, Mixins } from 'vue-property-decorator';
import ProjectMixin from '@/mixins/project';
import { projectPhase } from '@/filters/project-phase';
import DualPriceDisplay from './DualPriceDisplay.vue';

@Component({
    components: { DualPriceDisplay },
    filters: { projectPhase }
})
export default class ProjectMap extends Mixins(ProjectMixin) {}
